import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import type { CurrencyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';
import { BasisCurrencyService } from '@zaoblako/web/core/services/basis/basis-currency.service';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { BaseMultiSelectComponent } from '@zaoblako/web/shared/components/base-multi-select/base-multi-select.component';
import { DropdownUuidQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-uuid-query.dto';
import { Observable } from 'rxjs';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';

@Component({
  selector: 'crm-currency-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, SpinnerComponent, SafeHtmlPipe],
  templateUrl: './currency-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrencyMultiSelectComponent extends BaseMultiSelectComponent<CurrencyFindInterface> {
  public availableModule = 'BASIS';
  protected readonly entityCacheKind = 'currency';

  protected castToNumber = false;

  public constructor(private readonly basisCurrencyService: BasisCurrencyService) {
    super();
  }

  public findWithPagination(
    queryParams: Partial<DropdownUuidQueryInterface>
  ): Observable<PaginationFindInterface<CurrencyFindInterface>> {
    return this.basisCurrencyService.findWithPagination(queryParams);
  }

  public toCurrency(currency: any): CurrencyFindInterface {
    return currency as CurrencyFindInterface;
  }
}
